import React, { useState, useMemo } from 'react';

const PlannerIcons = {
  Grid: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>,
  Check: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  CalendarIcon: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
  Dollar: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Users: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>,
  Briefcase: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>,
  Palette: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" /></svg>,
  Settings: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
  Plus: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>,
  Trash: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>,
  Search: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>,
  Clock: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Document: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
  TableIcon: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zM12 6v14M4 13h16" /></svg>,
  Menu: () => <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>,
  X: () => <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>,
  Storefront: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" /></svg>,
  Chat: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>,
  Mail: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>,
  Box: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>,
  Printer: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>,
  Star: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>,
  Gift: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" /></svg>,
  Folder: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /></svg>,
  Share: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12s-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.368a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" /></svg>,
  Globe: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Utensils: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4h18z" /></svg>,
  Filter: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>,
  MapPin: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
};

export default function ProjectPacking({ project, updateProject }) {
  const [newItem, setNewItem] = useState({ 
    item: '', 
    responsible: 'Planner', 
    category: 'Decor', 
    qty: 1, 
    notes: '' 
  });
  
  const [filterCategory, setFilterCategory] = useState('All');
  const [filterResponsible, setFilterResponsible] = useState('All');
  const [filterStatus, setFilterStatus] = useState('All');

  const categories = ['Decor', 'Stationery', 'Attire', 'Tech/AV', 'Personal', 'Vendor Item', 'Other'];
  const responsibleParties = ['Planner', 'Couple', 'Best Man', 'Maid of Honor', 'Vendor', 'Family'];

  const packingList = project.packingList || [];

  const { packedCount, progress, filteredList } = useMemo(() => {
    const list = packingList.filter(i => {
      const matchCat = filterCategory === 'All' || i.category === filterCategory;
      const matchResp = filterResponsible === 'All' || i.responsible === filterResponsible;
      const matchStat = filterStatus === 'All' || 
                        (filterStatus === 'Packed' && i.status === 'Packed') || 
                        (filterStatus === 'Pending' && i.status !== 'Packed');
      return matchCat && matchResp && matchStat;
    });

    const packed = packingList.filter(i => i.status === 'Packed').length;
    const perc = packingList.length ? Math.round((packed / packingList.length) * 100) : 0;

    return { 
      packedCount: packed, 
      progress: perc, 
      filteredList: list.sort((a, b) => a.status === 'Packed' ? 1 : -1) 
    };
  }, [packingList, filterCategory, filterResponsible, filterStatus]);

  const addItem = (e) => {
    e.preventDefault();
    if (!newItem.item.trim()) return;
    
    updateProject(project.id, { 
      packingList: [
        ...packingList, 
        { 
          id: Date.now().toString(), 
          ...newItem, 
          status: 'Pending',
          createdAt: new Date().toISOString() 
        } 
      ] 
    });
    
    setNewItem({ 
      item: '', 
      responsible: newItem.responsible, 
      category: newItem.category, 
      qty: 1, 
      notes: '' 
    });
  };

  const removeItem = (id) => {
    if (window.confirm("Remove this item from the packing list?")) {
      updateProject(project.id, { 
        packingList: packingList.filter(i => i.id !== id) 
      });
    }
  };

  const updateItemStatus = (id, status) => {
    updateProject(project.id, { 
      packingList: packingList.map(i => i.id === id ? { ...i, status } : i) 
    });
  };

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header Dashboard */}
      <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col lg:flex-row gap-8 justify-between items-center">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 bg-pink-50 text-pink-600 rounded-2xl flex items-center justify-center text-3xl shadow-inner">
            <PlannerIcons.Box />
          </div>
          <div>
            <h3 className="font-serif text-2xl font-bold text-gray-900">Packing & Inventory</h3>
            <p className="text-sm text-gray-500 font-medium">Coordinate logistics and venue drop-offs.</p>
          </div>
        </div>
        
        <div className="w-full lg:w-72">
          <div className="flex justify-between text-xs font-bold text-gray-400 mb-2 uppercase tracking-widest">
            <span>Overall Readiness</span>
            <span className="text-pink-600">{progress}%</span>
          </div>
          <div className="h-3 w-full bg-gray-100 rounded-full overflow-hidden border border-gray-200">
            <div 
              className="h-full bg-gradient-to-r from-pink-500 to-rose-400 rounded-full transition-all duration-1000 ease-out shadow-sm" 
              style={{ width: `${progress}%` }} 
            />
          </div>
          <p className="text-[10px] text-gray-400 font-black mt-2 text-right uppercase tracking-tighter">
            {packedCount} of {packingList.length} items ready to go
          </p>
        </div>
      </div>

      {/* Add New Item Form */}
      <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm overflow-hidden relative">
        <div className="absolute top-0 left-0 w-full h-1 bg-gray-900"></div>
        <h4 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-4">Add New Item</h4>
        <form onSubmit={addItem} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 items-end">
          <div className="lg:col-span-2">
            <label className="text-[10px] font-bold text-gray-500 uppercase mb-1 block">Description</label>
            <input 
              type="text" 
              value={newItem.item} 
              onChange={e => setNewItem({ ...newItem, item: e.target.value })} 
              placeholder="e.g. Vintage Gold Easel" 
              className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-semibold focus:ring-2 focus:ring-pink-500 outline-none transition" 
              required 
            />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase mb-1 block">Category</label>
            <select 
              value={newItem.category} 
              onChange={e => setNewItem({ ...newItem, category: e.target.value })} 
              className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold focus:ring-2 focus:ring-pink-500 outline-none transition appearance-none"
            >
              {categories.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase mb-1 block">Quantity</label>
            <input 
              type="number" 
              min="1"
              value={newItem.qty} 
              onChange={e => setNewItem({ ...newItem, qty: parseInt(e.target.value) || 1 })} 
              className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold focus:ring-2 focus:ring-pink-500 outline-none transition" 
            />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase mb-1 block">Responsible</label>
            <select 
              value={newItem.responsible} 
              onChange={e => setNewItem({ ...newItem, responsible: e.target.value })} 
              className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold focus:ring-2 focus:ring-pink-500 outline-none transition appearance-none"
            >
              {responsibleParties.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <button 
            type="submit" 
            disabled={!newItem.item.trim()}
            className="w-full bg-gray-900 text-white p-3 rounded-xl text-sm font-black hover:bg-black transition shadow-md disabled:bg-gray-300 disabled:shadow-none flex items-center justify-center gap-2 transform active:scale-95"
          >
            <PlannerIcons.Plus /> Add
          </button>
          <div className="md:col-span-2 lg:col-span-6">
            <label className="text-[10px] font-bold text-gray-500 uppercase mb-1 block">Instructions / Notes (Optional)</label>
            <input 
              type="text" 
              value={newItem.notes} 
              onChange={e => setNewItem({ ...newItem, notes: e.target.value })} 
              placeholder="e.g. Fragile glass, requires 2 people to carry..." 
              className="w-full p-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium focus:ring-2 focus:ring-pink-500 outline-none transition" 
            />
          </div>
        </form>
      </div>

      {/* Filter Toolbar */}
      <div className="flex flex-wrap items-center gap-3 bg-white p-3 rounded-2xl border border-gray-200 shadow-sm">
        <div className="flex items-center gap-2 text-gray-400 px-2">
          <PlannerIcons.Filter />
          <span className="text-[10px] font-black uppercase tracking-widest">Filters:</span>
        </div>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="bg-gray-50 border border-gray-200 text-[11px] font-bold rounded-lg px-3 py-1.5 focus:ring-2 focus:ring-pink-500 outline-none">
          <option value="All">All Statuses</option>
          <option value="Pending">Pending Only</option>
          <option value="Packed">Packed Only</option>
        </select>
        <select value={filterCategory} onChange={e => setFilterCategory(e.target.value)} className="bg-gray-50 border border-gray-200 text-[11px] font-bold rounded-lg px-3 py-1.5 focus:ring-2 focus:ring-pink-500 outline-none">
          <option value="All">All Categories</option>
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <select value={filterResponsible} onChange={e => setFilterResponsible(e.target.value)} className="bg-gray-50 border border-gray-200 text-[11px] font-bold rounded-lg px-3 py-1.5 focus:ring-2 focus:ring-pink-500 outline-none">
          <option value="All">All Responsibility</option>
          {responsibleParties.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <button 
          onClick={() => { setFilterCategory('All'); setFilterResponsible('All'); setFilterStatus('All'); }}
          className="text-[10px] font-bold text-pink-600 hover:text-pink-700 ml-auto px-4"
        >
          Reset Filters
        </button>
      </div>

      {/* Item Table/List */}
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        {filteredList.length > 0 ? (
          <div className="overflow-x-auto custom-scrollbar">
            {/* Desktop Table View */}
            <table className="hidden md:table w-full text-sm text-left">
              <thead className="bg-gray-50 border-b border-gray-200 text-[10px] uppercase font-black text-gray-400 tracking-[0.1em]">
                <tr>
                  <th className="px-6 py-4 w-16 text-center">Status</th>
                  <th className="px-6 py-4">Item Details</th>
                  <th className="px-6 py-4 w-24 text-center">Qty</th>
                  <th className="px-6 py-4">Responsibility</th>
                  <th className="px-6 py-4 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredList.map(item => (
                  <tr key={item.id} className={`hover:bg-gray-50/50 group transition-colors ${item.status === 'Packed' ? 'bg-emerald-50/10' : ''}`}>
                    <td className="px-6 py-4 text-center">
                      <input 
                        type="checkbox" 
                        checked={item.status === 'Packed'} 
                        onChange={() => updateItemStatus(item.id, item.status === 'Packed' ? 'Pending' : 'Packed')} 
                        className="w-6 h-6 text-pink-600 rounded-lg border-2 border-gray-300 focus:ring-pink-500 cursor-pointer transition-transform active:scale-90" 
                      />
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex flex-col">
                        <span className={`font-bold text-base ${item.status === 'Packed' ? 'line-through text-gray-400' : 'text-gray-900'}`}>
                          {item.item}
                        </span>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="bg-gray-100 text-gray-500 px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-wider border border-gray-200">
                            {item.category}
                          </span>
                          {item.notes && <span className="text-[11px] text-gray-400 font-medium italic">"{item.notes}"</span>}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                       <div className="inline-flex items-center bg-gray-50 rounded-lg border border-gray-200 px-2 py-1">
                          <span className="font-black text-gray-900">{item.qty || 1}</span>
                       </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider border border-blue-100">
                        {item.responsible}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right">
                       <button 
                         onClick={() => removeItem(item.id)} 
                         className="opacity-0 group-hover:opacity-100 p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-full transition-all"
                         title="Delete Item"
                       >
                         <PlannerIcons.Trash />
                       </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Mobile Cards View */}
            <div className="md:hidden flex flex-col divide-y divide-gray-100">
              {filteredList.map(item => (
                <div key={item.id} className={`p-5 flex gap-4 items-start transition-colors ${item.status === 'Packed' ? 'bg-emerald-50/20 opacity-75' : 'bg-white'}`}>
                  <input 
                    type="checkbox" 
                    checked={item.status === 'Packed'} 
                    onChange={() => updateItemStatus(item.id, item.status === 'Packed' ? 'Pending' : 'Packed')} 
                    className="mt-1 w-8 h-8 text-pink-600 rounded-xl border-2 border-gray-300 focus:ring-pink-500 cursor-pointer flex-shrink-0" 
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start gap-2">
                       <span className={`font-bold text-lg leading-tight block mb-1 ${item.status === 'Packed' ? 'line-through text-gray-400' : 'text-gray-900'}`}>
                         {item.item}
                       </span>
                       <span className="bg-gray-900 text-white text-xs font-black px-2 py-1 rounded-lg shrink-0">x{item.qty || 1}</span>
                    </div>
                    <div className="flex flex-wrap gap-2 items-center mb-2">
                       <span className="bg-gray-100 text-gray-500 px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-wider border border-gray-200">
                         {item.category}
                       </span>
                       <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-wider border border-blue-100">
                         {item.responsible}
                       </span>
                    </div>
                    {item.notes && <p className="text-xs text-gray-500 italic mb-2 leading-relaxed bg-gray-50 p-2 rounded-lg border border-gray-100">{item.notes}</p>}
                    <button 
                      onClick={() => removeItem(item.id)} 
                      className="text-xs font-bold text-red-500 bg-red-50 px-3 py-1.5 rounded-lg border border-red-100"
                    >
                      Remove Item
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-[400px] text-center px-6">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center text-5xl mb-6 grayscale opacity-50 shadow-inner">
              <PlannerIcons.Box />
            </div>
            <h5 className="text-xl font-bold text-gray-900 mb-2 font-serif">Packing List is Empty</h5>
            <p className="text-sm text-gray-500 max-w-sm leading-relaxed">
              {filterCategory !== 'All' || filterResponsible !== 'All' || filterStatus !== 'All' 
                ? "No items match your active filters. Try clearing them to see all inventory." 
                : "Coordinate what needs to be brought to the venue. Start by adding items like welcome signs, attire, or tech gear above."}
            </p>
            {(filterCategory !== 'All' || filterResponsible !== 'All' || filterStatus !== 'All') && (
              <button 
                onClick={() => { setFilterCategory('All'); setFilterResponsible('All'); setFilterStatus('All'); }}
                className="mt-6 px-6 py-2.5 bg-gray-900 text-white rounded-xl font-bold text-sm hover:bg-black transition shadow-md"
              >
                Clear All Filters
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}